import isInIframe from '@app/helpers/is-in-iframe';

declare global {
  interface Window {
    loadedFromMobile?: boolean;
  }
}

export const CREATION_SOURCES = {
  WEB_APP: 'WebApp',
  CONNECT: 'Connect',
  MOBILE: 'MobileV2',
};

export const getCreationSource = () => {
  if (isInIframe()) {
    return CREATION_SOURCES.CONNECT;
  }
  if (window?.isLoadedInWKWebView || window?.loadedFromMobile) {
    return CREATION_SOURCES.MOBILE;
  }

  return CREATION_SOURCES.WEB_APP;
};
